import { IconButton } from '@mui/material';
import { styled } from '@mui/material/styles';

import { TIconButton } from './types';

export const StyledIconButton = styled(IconButton)<TIconButton>(
  ({ theme, variant, color }) => ({
    color: theme.palette.custom.black[100],
    margin: 0,

    ...(variant === 'outlined' && {
      backgroundColor: 'transparent',
      border: `1px solid ${theme.palette.custom.grey2}`,

      '&:focus-visible': {
        backgroundColor: theme.palette.custom.grey2,
      },

      '&:hover': {
        color: theme.palette.common.white,
        backgroundColor: theme.palette.primary.main,
      },

      '&:active': {
        boxShadow: `inset 0px 2px 8px 0px ${theme.palette.custom.opacityBlack25}`,
      },
    }),

    ...(variant === 'icon' && {
      backgroundColor: 'transparent',
      color: theme.palette.custom.black[20],
      border: `1px solid transparent`,

      '&:focus-visible': {
        border: `1px solid ${theme.palette.custom.grey2}`,
      },

      '&:hover': {
        color: theme.palette.custom.black[60],
      },

      '&:active': {
        color: theme.palette.custom.black[40],
      },

      '&:disabled': {
        border: `1px solid transparent`,
      },
    }),

    ...(color === 'inherit' && {
      color: 'inherit',
    }),
  })
);
